define('views/modules/questionnaire/member/fill-questionnaire-panel',[
    // libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/panel/base-panel',
    'views/modules/questionnaire/member/fill-questionnaire-content'

], function(
    // libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    VFillQuestionnaireContent
) {

    var VFillQuestionnairePanel = VBasePanel.extend({
        header: {
            title: "Fill a questionnaire",
            subtitle: "Fill the questionnaire and send it back to your supervisor",
        },
        tabs: [{ id: 'questionnaire', title: 'questionnaire:Questionnaire', icon: 'sl-icon-info', active: true }],
        content: {
            questionnaire: VFillQuestionnaireContent,
        },
        defaultView: 'questionnaire',

        initialize: function(opt) {
            _.extend(this, _.pick(opt, 'group', 'questionnaire', 'url'));

            var view = this.getView('questionnaire', {
                group: this.group,
                questionnaire: this.questionnaire,
                url: this.url,
                model: this.model
            });

            this.listenTo(view, { 'form:success': this.close });
        },

    });

    return VFillQuestionnairePanel;
});

